(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4990],{

/***/ 8735:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/playlists/[canais]",
      function () {
        return __webpack_require__(7875);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ LastVideosPlaylist; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7590);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Home_FeaturedLastNews__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2826);
/* harmony import */ var _components_Listing_PlaylistHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9945);
/* harmony import */ var _components_Layout_ItemListLastNews_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2747);
/* harmony import */ var _components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3078);








var __N_SSP = true;
function LastVideosPlaylist(param) {
    var homeData = param.homeData, navBarData = param.navBarData, tagsData = param.tagsData, segmentacoes = param.segmentacoes, timelineData = param.timelineData;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var schema = homeData.schema;
    var _data = homeData.data, titulo = _data.titulo, descricao = _data.descricao, breadcrumb = _data.breadcrumb;
    var canais = router.query.canais;
    var AdsTypeGenerators = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
        return __webpack_require__.e(/* import() */ 8463).then(__webpack_require__.bind(__webpack_require__, 2444));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2444)
                ];
            }
        },
        ssr: false
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        layoutData: {
            navBarData: navBarData,
            tagsData: tagsData,
            segmentacoes: segmentacoes,
            schema: schema
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Listing_PlaylistHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                titulo: titulo,
                descricao: descricao,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                desktopOnly: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_ItemListLastNews_styles__WEBPACK_IMPORTED_MODULE_6__/* .AdContainer */ .g1, {
                    noPadding: true,
                    billboard: true,
                    style: {
                        background: "transparent"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AdsTypeGenerators, {
                        type: "billboard/main/listing"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Home_FeaturedLastNews__WEBPACK_IMPORTED_MODULE_4__["default"], {
                featuredLastNewsData: timelineData === null || timelineData === void 0 ? void 0 : timelineData.timeline,
                rootPage: "video/playlists/".concat(canais),
                textTitle: "\xdaltimos V\xeddeos",
                headingTag: "h2",
                routeType: "tipo",
                route: "video/".concat(canais)
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,1658,8802,7590,944,2826,7022,9774,2888,179], function() { return __webpack_exec__(8735); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);